export default __webpack_public_path__ + "static/media/eco3.577ed7f6.jpg";